import SyCollapse from "./sy-collapse";

export default SyCollapse